import request from '@/utils/request'

export function login(data) {
    return request({
        url: 'service/Qg.Services.AuthService/Login',
        method: 'post',
        data
    })
}

export function getUserAuthPages(data) {
    return request({
        url: 'service/Qg.Services.AuthService/GetUserAuthPages',
        method: 'get',
        params: data
    })
}

export function logout(data) {
    return request({
        url: 'service/Qg.Services.AuthService/Logout',
        method: 'get',
        params: data
    })
}




